export type TableAdfNodeType = 'table' | 'tableRow' | 'tableCell' | 'tableHeader';

export type ActionItemAdfNodeType = 'taskList' | 'taskItem';

export const TABLE_NODE_TYPES: TableAdfNodeType[] = [
	'table',
	'tableRow',
	'tableCell',
	'tableHeader',
];

export const ACTION_ITEM_NODE_TYPES: ActionItemAdfNodeType[] = ['taskList', 'taskItem'];

